// // import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// // import config from '../Common/Configurations/APIConfig';
// // import DefaultData from '../Common/CompanyData/DefaultData'; // Import the DefaultData
// // import './BusinessDashboard.css';

// // function BusinessDashboard() {
// //   const [salonId, setSalonId] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [currentMonth, setCurrentMonth] = useState('');
  
// //   // Unified dashboard state
// //   const [dashboard, setDashboard] = useState({
// //     // From Dashboard API
// //     todayAppointmentsList: [],
    
// //   summary: {
// //   totalAppointments: 0,
// //   todayAppointments: 0,
// //   totalRevenue: 0,
// //   completedThisMonth: 0,
// //   totalStaff: 0,

// //   // ✅ ADD ONLY
// //   pendingAppointments: 0,
// //   upcomingAppointments: 0,
// //   confirmedAppointments: 0,
// //   cancelledAppointments: 0
// // }
// //   });

// //   // Get currency from DefaultData
// //   const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

// //   // Get SalonId from localStorage
// //   useEffect(() => {
// //     const authData = getAuthDataFromStorage();
    
// //     if (authData && authData.salonId) {
// //       setSalonId(authData.salonId);
// //       // Set current month name
// //       setCurrentMonth(new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' }));
// //     } else {
// //       setError('Please login to access dashboard');
// //       setLoading(false);
// //     }
// //   }, []);

// //   // Fetch all data
// //   useEffect(() => {
// //     if (salonId) {
// //       fetchAllDashboardData();
// //     }
// //   }, [salonId]);

// //   const getAuthDataFromStorage = () => {
// //     try {
// //       const authString = localStorage.getItem('auth');
// //       if (authString) return JSON.parse(authString);
      
// //       const salonId = localStorage.getItem('salonId');
// //       if (salonId) {
// //         return {
// //           salonId: salonId,
// //           roleName: localStorage.getItem('roleName')
// //         };
// //       }
// //       return null;
// //     } catch (error) {
// //       console.error('Error parsing auth data:', error);
// //       return null;
// //     }
// //   };

// //   const fetchAllDashboardData = async () => {
// //     try {
// //       setLoading(true);
// //       const token = localStorage.getItem('token');
      
// //       // Fetch dashboard data
// //       const dashboardRes = await axios.get(
// //         `${config.APIACTIVEURL}Dashboard/salon/${salonId}`,
// //         { headers: { 'Authorization': `Bearer ${token}` } }
// //       );

// //       // Fetch current month revenue
// //       const today = new Date();
// //       const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
// //       const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      
// //       const revenueRes = await axios.get(
// //         `${config.APIACTIVEURL}Dashboard/salon/${salonId}/revenue`,
// //         {
// //           params: {
// //             startDate: startDate.toISOString().split('T')[0],
// //             endDate: endDate.toISOString().split('T')[0]
// //           },
// //           headers: { 'Authorization': `Bearer ${token}` }
// //         }
// //       );

// //       if (dashboardRes.data.success && revenueRes.data.success) {
// //         const dashboardData = dashboardRes.data.data;
// //         const revenueData = revenueRes.data.data;
        
// //         setDashboard({
// //           todayAppointmentsList: dashboardData.todayAppointmentsList || [],
// //           summary: {
// //             totalAppointments: dashboardData.totalAppointments || 0,
// //             todayAppointments: dashboardData.todayAppointments || 0,
// //             totalRevenue: revenueData.totalRevenue || 0,
// //             completedThisMonth: revenueData.totalCompletedAppointments || 0,
// //             totalStaff: dashboardData.totalStaff || 0,
// //             pendingAppointments: dashboardData.pendingAppointments || 0,
// //             upcomingAppointments: dashboardData.upcomingAppointments || 0,
// //             confirmedAppointments: dashboardData.confirmedAppointments || 0,
// //             cancelledAppointments: dashboardData.cancelledAppointments || 0
// //           }
// //         });
// //       }
// //     } catch (error) {
// //       console.error('Error fetching dashboard data:', error);
// //       setError('Failed to load dashboard data');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Get status color and label
// //   const getAppointmentStatus = (status) => {
// //     const statusConfig = {
// //       'pending': { color: '#FF9800', label: 'Pending' },
// //       'confirmed': { color: '#4CAF50', label: 'Confirmed' },
// //       'completed': { color: '#2196F3', label: 'Completed' },
// //       'cancelled': { color: '#F44336', label: 'Cancelled' }
// //     };
    
// //     const config = statusConfig[status?.toLowerCase()] || { color: '#9E9E9E', label: status };
// //     return {
// //       color: config.color,
// //       label: config.label,
// //       bgColor: `${config.color}15`
// //     };
// //   };

// //   // Format time
// //   const formatTime = (dateString) => {
// //     return new Date(dateString).toLocaleTimeString([], { 
// //       hour: '2-digit', 
// //       minute: '2-digit' 
// //     });
// //   };

// //   // Calculate average revenue
// //   const getAverageRevenue = () => {
// //     if (dashboard.summary.completedThisMonth > 0) {
// //       return (dashboard.summary.totalRevenue / dashboard.summary.completedThisMonth).toFixed(2);
// //     }
// //     return '0.00';
// //   };

// //   // Format currency with NGN
// //   const formatCurrency = (amount) => {
// //     return `${currency} ${amount || '0.00'}`;
// //   };

// //   if (loading) {
// //     return (
// //       <div className="dashboard-loading">
// //         <div className="loading-spinner"></div>
// //         <p>Loading dashboard...</p>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <div className="dashboard-error">
// //         <div className="error-icon">⚠️</div>
// //         <h3>Unable to Load Dashboard</h3>
// //         <p>{error}</p>
// //         <button className="retry-btn" onClick={fetchAllDashboardData}>
// //           Try Again
// //         </button>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="dashboard-container">
// //       {/* Header */}
// //       <div className="dashboard-header">
// //         <div className="header-content">
// //           <h1>
// //             <span className="header-icon">📊</span>
// //             Salon Dashboard
// //           </h1>
// //           <p className="header-subtitle">{currentMonth} Overview</p>
// //         </div>
// //         <div className="header-date">
// //           <span className="date-icon">📅</span>
// //           {new Date().toLocaleDateString('en-US', { 
// //             weekday: 'long',
// //             month: 'short',
// //             day: 'numeric',
// //             year: 'numeric'
// //           })}
// //         </div>
// //       </div>

// //       {/* Key Metrics Grid */}
// //       <div className="metrics-grid">
// //         <div className="metric-card revenue-card">
// //           <div className="metric-icon">📋</div> {/* File emoji */}
// //           <div className="metric-content">
// //             <div className="metric-value">{dashboard.summary.totalAppointments}</div>
// //             <div className="metric-label">Total Appointments</div>
// //           </div>
// //         </div>
// //         {/* Today's Appointments */}
// //         <div className="metric-card appointment-card">
// //           <div className="metric-icon">📅</div>
// //           <div className="metric-content">
// //             <div className="metric-value">{dashboard.summary.todayAppointments}</div>
// //             <div className="metric-label">Today's Appointments</div>
// //             <div className="metric-detail">
// //               {dashboard.todayAppointmentsList.length} scheduled
// //             </div>
// //           </div>
// //         </div>

// //         {/* Completed Appointments */}
// //         <div className="metric-card completed-card">
// //           <div className="metric-icon">✅</div>
// //           <div className="metric-content">
// //             <div className="metric-value">{dashboard.summary.completedThisMonth}</div>
// //             <div className="metric-label">Completed This Month</div>
// //             <div className="metric-detail">
// //               Revenue generating
// //             </div>
// //           </div>
// //         </div>

// //         {/* Total Staff */}
// //         <div className="metric-card staff-card">
// //           <div className="metric-icon">👥</div>
// //           <div className="metric-content">
// //             <div className="metric-value">{dashboard.summary.totalStaff}</div>
// //             <div className="metric-label">Total Staff</div>
// //             <div className="metric-detail">
// //               Team members
// //             </div>
// //           </div>
// //         </div>
// //         {/* ✅ Appointment Status Counts */}
// // <div className="metric-card">
// //   <div className="metric-icon">⏳</div>
// //   <div className="metric-content">
// //     <div className="metric-value">
// //       {dashboard.summary.pendingAppointments}
// //     </div>
// //     <div className="metric-label">Pending Appointments</div>
// //   </div>
// // </div>

// // <div className="metric-card">
// //   <div className="metric-icon">⏰</div>
// //   <div className="metric-content">
// //     <div className="metric-value">
// //       {dashboard.summary.upcomingAppointments}
// //     </div>
// //     <div className="metric-label">Upcoming Appointments</div>
// //   </div>
// // </div>

// // <div className="metric-card">
// //   <div className="metric-icon">✔️</div>
// //   <div className="metric-content">
// //     <div className="metric-value">
// //       {dashboard.summary.confirmedAppointments}
// //     </div>
// //     <div className="metric-label">Confirmed Appointments</div>
// //   </div>
// // </div>

// // <div className="metric-card">
// //   <div className="metric-icon">❌</div>
// //   <div className="metric-content">
// //     <div className="metric-value">
// //       {dashboard.summary.cancelledAppointments}
// //     </div>
// //     <div className="metric-label">Cancelled Appointments</div>
// //   </div>
// // </div>

// //       </div>

// //       {/* Main Content Area */}
// //       <div className="dashboard-content">
// //         {/* Today's Appointments - SIMPLE TABLE FORMAT */}
// //         <div className="content-card appointments-section">
// //           <div className="section-header">
// //             <h2>
// //               <span className="section-icon">🎯</span>
// //               Today's Schedule
// //               <span className="section-count">{dashboard.summary.todayAppointments}</span>
// //             </h2>
// //             <div className="section-subtitle">All appointments scheduled for today</div>
// //           </div>

// //           <div className="appointments-table-container">
// //             <div className="appointments-table">
// //               {/* Table Header */}
// //               <div className="table-header">
// //                 <div className="table-header-row">
// //                   <div className="header-cell time-header">Time</div>
// //                   <div className="header-cell customer-header">Customer Details</div>
// //                   <div className="header-cell service-header">Service & Staff</div>
// //                   <div className="header-cell status-header">Status</div>
// //                 </div>
// //               </div>

// //               {/* Table Body */}
// //               <div className="table-body">
// //                 {dashboard.todayAppointmentsList.length > 0 ? (
// //                   dashboard.todayAppointmentsList.map((appointment, index) => {
// //                     const status = getAppointmentStatus(appointment.status);
// //                     return (
// //                       <div key={appointment.appointmentId || index} className="table-row">
// //                         <div className="table-cell time-cell">
// //                           {formatTime(appointment.startTime)}
// //                         </div>
// //                         <div className="table-cell customer-cell">
// //                           <div className="customer-info">
// //                             <div className="customer-name">
// //                               {appointment.customerName || 'Customer'}
// //                             </div>
// //                             <div className="customer-phone">
// //                               {appointment.customerPhone || 'N/A'}
// //                             </div>
// //                           </div>
// //                         </div>
// //                         <div className="table-cell service-cell">
// //                           <div className="service-details">
// //                             <div className="service-name">
// //                               {appointment.serviceName}
// //                             </div>
// //                             <div className="staff-name">
// //                               {appointment.staffName}
// //                             </div>
// //                             <div className="salon-name">
// //                               {appointment.salonName}
// //                             </div>
// //                           </div>
// //                         </div>
// //                         <div className="table-cell status-cell">
// //                           <span className="status-text" style={{ color: status.color }}>
// //                             {status.label}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     );
// //                   })
// //                 ) : (
// //                   <div className="empty-table-row">
// //                     <div className="empty-table-cell">
// //                       <div className="empty-state">
// //                         <div className="empty-icon">📅</div>
// //                         <h3>No Appointments Today</h3>
// //                         <p>There are no appointments scheduled for today</p>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Monthly Summary */}
// //         <div className="content-card summary-section">
// //           <div className="section-header">
// //             <h2>
// //               <span className="section-icon">📈</span>
// //               Monthly Performance
// //               <span className="section-month">{currentMonth}</span>
// //             </h2>
// //             <div className="section-subtitle">Revenue and appointment summary</div>
// //           </div>

// //           <div className="summary-stats">
// //             <div className="summary-stat">
// //               <div className="stat-icon revenue-icon">💰</div>
// //               <div className="stat-content">
// //                 <div className="stat-label">Total Revenue</div>
// //                 <div className="stat-value">{formatCurrency(dashboard.summary.totalRevenue)}</div>
// //                 <div className="stat-detail">
// //                   Generated from {dashboard.summary.completedThisMonth} appointments
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="summary-stat">
// //               <div className="stat-icon appointment-icon">📅</div>
// //               <div className="stat-content">
// //                 <div className="stat-label">Average per Appointment</div>
// //                 <div className="stat-value">{formatCurrency(getAverageRevenue())}</div>
// //                 <div className="stat-detail">
// //                   Based on completed appointments
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="summary-stat">
// //               <div className="stat-icon success-icon">✅</div>
// //               <div className="stat-content">
// //                 <div className="stat-label">Completion Rate</div>
// //                 <div className="stat-value">
// //                   {dashboard.summary.completedThisMonth > 0 ? '100%' : '0%'}
// //                 </div>
// //                 <div className="stat-detail">
// //                   {dashboard.summary.completedThisMonth} successful appointments
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="summary-footer">
// //             <div className="footer-note">
// //               Data updates in real-time from your salon management system
// //             </div>
// //             <div className="footer-actions">
// //               <button className="refresh-btn" onClick={fetchAllDashboardData}>
// //                 <span className="refresh-icon">🔄</span>
// //                 Refresh Data
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default BusinessDashboard;
// //web view 














import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../Common/Configurations/APIConfig';
import DefaultData from '../Common/CompanyData/DefaultData'; 
import './BusinessDashboard.css';

function BusinessDashboard() {
  const [salonId, setSalonId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentMonth, setCurrentMonth] = useState('');
  
  const [dashboard, setDashboard] = useState({
    todayAppointmentsList: [],
    summary: {
      totalAppointments: 0,
      todayAppointments: 0,
      totalRevenue: 0,
      completedThisMonth: 0,
      totalStaff: 0,
      pendingAppointments: 0,
      upcomingAppointments: 0,
      confirmedAppointments: 0,
      cancelledAppointments: 0
    }
  });

  const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

  useEffect(() => {
    const authData = getAuthDataFromStorage();
    if (authData && authData.salonId) {
      setSalonId(authData.salonId);
      setCurrentMonth(new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' }));
    } else {
      setError('Please login to access dashboard');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (salonId) {
      fetchAllDashboardData();
    }
  }, [salonId]);

  const getAuthDataFromStorage = () => {
    try {
      const authString = localStorage.getItem('auth');
      if (authString) return JSON.parse(authString);
      const sId = localStorage.getItem('salonId');
      if (sId) {
        return { salonId: sId, roleName: localStorage.getItem('roleName') };
      }
      return null;
    } catch (error) {
      console.error('Error parsing auth data:', error);
      return null;
    }
  };

  const fetchAllDashboardData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const dashboardRes = await axios.get(
        `${config.APIACTIVEURL}Dashboard/salon/${salonId}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      const today = new Date();
      const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      
      const revenueRes = await axios.get(
        `${config.APIACTIVEURL}Dashboard/salon/${salonId}/revenue`,
        {
          params: {
            startDate: startDate.toISOString().split('T')[0],
            endDate: endDate.toISOString().split('T')[0]
          },
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (dashboardRes.data.success && revenueRes.data.success) {
        const dashboardData = dashboardRes.data.data;
        const revenueData = revenueRes.data.data;
        setDashboard({
          todayAppointmentsList: dashboardData.todayAppointmentsList || [],
          summary: {
            totalAppointments: dashboardData.totalAppointments || 0,
            todayAppointments: dashboardData.todayAppointments || 0,
            totalRevenue: revenueData.totalRevenue || 0,
            completedThisMonth: revenueData.totalCompletedAppointments || 0,
            totalStaff: dashboardData.totalStaff || 0,
            pendingAppointments: dashboardData.pendingAppointments || 0,
            upcomingAppointments: dashboardData.upcomingAppointments || 0,
            confirmedAppointments: dashboardData.confirmedAppointments || 0,
            cancelledAppointments: dashboardData.cancelledAppointments || 0
          }
        });
      }
    } catch (error) {
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const getAppointmentStatus = (status) => {
    const statusConfig = {
      'pending': { color: '#FF9800', label: 'Pending' },
      'confirmed': { color: '#4CAF50', label: 'Confirmed' },
      'completed': { color: '#2196F3', label: 'Completed' },
      'cancelled': { color: '#F44336', label: 'Cancelled' }
    };
    const config = statusConfig[status?.toLowerCase()] || { color: '#9E9E9E', label: status };
    return { color: config.color, label: config.label, bgColor: `${config.color}15` };
  };

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const getAverageRevenue = () => {
    if (dashboard.summary.completedThisMonth > 0) {
      return (dashboard.summary.totalRevenue / dashboard.summary.completedThisMonth).toFixed(2);
    }
    return '0.00';
  };

  const formatCurrency = (amount) => `${currency} ${amount || '0.00'}`;

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <div className="error-icon">⚠️</div>
        <h3>Unable to Load Dashboard</h3>
        <p>{error}</p>
        <button className="retry-btn" onClick={fetchAllDashboardData}>Try Again</button>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <h1><span className="header-icon">📊</span> Salon Dashboard</h1>
          <p className="header-subtitle">{currentMonth} Overview</p>
        </div>
        <div className="header-date">
          <span className="date-icon">📅</span>
          {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="metrics-grid">
        <div className="metric-card revenue-card">
          <div className="metric-icon">📋</div>
          <div className="metric-content">
            <div className="metric-value">{dashboard.summary.totalAppointments}</div>
            <div className="metric-label">Total Appointments</div>
          </div>
        </div>
        <div className="metric-card appointment-card">
          <div className="metric-icon">📅</div>
          <div className="metric-content">
            <div className="metric-value">{dashboard.summary.todayAppointments}</div>
            <div className="metric-label">Today's Appointments</div>
          </div>
        </div>
        <div className="metric-card completed-card">
          <div className="metric-icon">✅</div>
          <div className="metric-content">
            <div className="metric-value">{dashboard.summary.completedThisMonth}</div>
            <div className="metric-label">Completed This Month</div>
          </div>
        </div>
        <div className="metric-card staff-card">
          <div className="metric-icon">👥</div>
          <div className="metric-content">
            <div className="metric-value">{dashboard.summary.totalStaff}</div>
            <div className="metric-label">Total Staff</div>
          </div>
        </div>
        <div className="metric-card">
          <div className="metric-icon">⏳</div>
          <div className="metric-content">
            <div className="metric-value">{dashboard.summary.pendingAppointments}</div>
            <div className="metric-label">Pending</div>
          </div>
        </div>
        <div className="metric-card">
          <div className="metric-icon">✔️</div>
          <div className="metric-content">
            <div className="metric-value">{dashboard.summary.confirmedAppointments}</div>
            <div className="metric-label">Confirmed</div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="dashboard-content">
        {/* Today's Schedule */}
        <div className="content-card appointments-section">
          <div className="section-header">
            <h2>
              <span className="section-icon">🎯</span> Today's Schedule
              <span className="section-count">{dashboard.summary.todayAppointments}</span>
            </h2>
          </div>

          <div className="appointments-table-container">
            {/* Desktop View Table */}
            <div className="appointments-table d-none d-lg-flex">
              <div className="table-header">
                <div className="table-header-row">
                  <div className="header-cell time-header">Time</div>
                  <div className="header-cell customer-header">Customer</div>
                  <div className="header-cell service-header">Service & Staff</div>
                  <div className="header-cell status-header">Status</div>
                </div>
              </div>
              <div className="table-body">
                {dashboard.todayAppointmentsList.length > 0 ? (
                  dashboard.todayAppointmentsList.map((appointment, index) => {
                    const status = getAppointmentStatus(appointment.status);
                    return (
                      <div key={appointment.appointmentId || index} className="table-row">
                        <div className="table-cell time-cell">{formatTime(appointment.startTime)}</div>
                        <div className="table-cell customer-cell">
                          <div className="customer-info">
                            <div className="customer-name">{appointment.customerName || 'Customer'}</div>
                            <div className="customer-phone">{appointment.customerPhone || 'N/A'}</div>
                          </div>
                        </div>
                        <div className="table-cell service-cell">
                          <div className="service-details">
                            <div className="service-name">{appointment.serviceName}</div>
                            <div className="staff-name">{appointment.staffName}</div>
                          </div>
                        </div>
                        <div className="table-cell status-cell">
                          <span className="status-text" style={{ color: status.color }}>{status.label}</span>
                        </div>
                      </div>
                    );
                  })
                ) : <div className="p-5 text-center text-muted">No appointments today</div>}
              </div>
            </div>

            {/* Mobile View Cards */}
            <div className="d-lg-none p-3">
               {dashboard.todayAppointmentsList.length > 0 ? (
                  dashboard.todayAppointmentsList.map((appointment, index) => {
                    const status = getAppointmentStatus(appointment.status);
                    return (
                      <div key={index} className="mobile-dash-card mb-3 p-3 border rounded-3 bg-white shadow-sm">
                        <div className="d-flex justify-content-between mb-2">
                           <span className="fw-bold text-primary">{formatTime(appointment.startTime)}</span>
                           <span className="small fw-bold" style={{ color: status.color }}>{status.label}</span>
                        </div>
                        <h6 className="fw-bold mb-1">{appointment.customerName}</h6>
                        <div className="small text-muted mb-2">{appointment.serviceName}</div>
                        <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                           <small><i className="ri-user-line me-1"></i> {appointment.staffName}</small>
                           <small className="text-muted">{appointment.customerPhone}</small>
                        </div>
                      </div>
                    );
                  })
               ) : <div className="text-center py-4 text-muted">No appointments scheduled</div>}
            </div>
          </div>
        </div>

        {/* Monthly Summary */}
        <div className="content-card summary-section">
          <div className="section-header">
            <h2><span className="section-icon">📈</span> Performance <span className="section-month">{currentMonth}</span></h2>
          </div>
          <div className="summary-stats">
            <div className="summary-stat">
              <div className="stat-icon revenue-icon">💰</div>
              <div className="stat-content">
                <div className="stat-label">Total Revenue</div>
                <div className="stat-value">{formatCurrency(dashboard.summary.totalRevenue)}</div>
                <div className="stat-detail">From {dashboard.summary.completedThisMonth} appointments</div>
              </div>
            </div>
            <div className="summary-stat">
              <div className="stat-icon appointment-icon">📅</div>
              <div className="stat-content">
                <div className="stat-label">Avg. Revenue</div>
                <div className="stat-value">{formatCurrency(getAverageRevenue())}</div>
                <div className="stat-detail">Per completed booking</div>
              </div>
            </div>
          </div>
          <div className="summary-footer">
            <div className="footer-note d-none d-sm-block">Real-time data synchronization</div>
            <button className="refresh-btn" onClick={fetchAllDashboardData}>
              <span className="refresh-icon">🔄</span> Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessDashboard;